
import apiConfig from '@/config/api.config'
import ImageUploader from '@/components/common/ImageUploader.vue'

export default {
  name: 'GiftManage',
  components: {
    ImageUploader
  },
  data () {
    return {
      gifts: [],
      showAddModal: false,
      editingGift: null,
      giftForm: {
        name: '',
        image: '',
        unit: '个',
        status: 'active'
      }
    }
  },
  created () {
    this.fetchGifts()
  },
  methods: {
    async fetchGifts () {
      try {
        const token = localStorage.getItem('token')
        const res = await this.axios.get(`/admin/gifts`, {
          headers: { Authorization: `Bearer ${token}` }
        })
        if (res.data.code === 200) {
          this.gifts = res.data.data
        }
      } catch (err) {
        console.error('获取赠品列表失败:', err)
      }
    },
    editGift (gift) {
      this.editingGift = gift
      this.giftForm = {
        name: gift.name,
        image: gift.image || '',
        unit: gift.unit || '个',
        status: gift.status || 'active'
      }
    },
    async saveGift () {
      try {
        const token = localStorage.getItem('token')
        if (this.editingGift) {
          await this.axios.put(
            `/admin/gifts/${this.editingGift.id}`,
            this.giftForm,
            { headers: { Authorization: `Bearer ${token}` } }
          )
          alert('赠品已更新')
        } else {
          await this.axios.post(
            `/admin/gifts`,
            this.giftForm,
            { headers: { Authorization: `Bearer ${token}` } }
          )
          alert('赠品已创建')
        }
        this.closeModal()
        this.fetchGifts()
      } catch (err) {
        alert('保存失败')
      }
    },
    async deleteGift (id) {
      if (!confirm('确定要删除这个赠品吗？')) return
      try {
        const token = localStorage.getItem('token')
        await this.axios.delete(
          `/admin/gifts/${id}`,
          { headers: { Authorization: `Bearer ${token}` } }
        )
        alert('赠品已删除')
        this.fetchGifts()
      } catch (err) {
        alert('删除失败')
      }
    },
    closeModal () {
      this.showAddModal = false
      this.editingGift = null
      this.giftForm = {
        name: '',
        image: '',
        unit: '个',
        status: 'active'
      }
    },
    formatDate (date) {
      if (!date) return '-'
      return new Date(date).toLocaleDateString('zh-CN')
    }
  }
}
